import styled from '@emotion/styled'
import { modalAIAssistant } from 'Components/ModalAiAssistantBee/recoil/state/modal'
import { storeGet } from 'Helpers/localStorage'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { STORE_KEY_ACCOUNT, evalCondition, notifyParent } from 'mailup-react-helpers'
import {
  Flex,
  Icon,
  Link,
  PageHeader,
  TruncateAndTooltip
} from 'mailup-web-components'
import { pageState } from 'Pages/MessageEdit/recoil/state/page'
import { previewState } from 'Pages/MessageEdit/recoil/state/preview'
import SaveMessageButton from 'Pages/MessageEdit/SaveMessageButton'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import aiIcon from '../../../img/aiwizard.svg'
import { openAIState } from '../recoil/state/editor'

const StyledImgAI = styled.img`
  position: relative;
  top: -3px;
  margin-right: 4px;
`

const StyledLink = styled(Link)`
  margin-right: 8px;
  white-space: nowrap;
`

const Header = () => {
  const [redirectUrl] = useRedirectorUrl()
  const intl = useIntl()
  const { title } = useRecoilValue(pageState)
  const { active: previewActive } = useRecoilValue(previewState)
  const closePreview = useResetRecoilState(previewState)
  const setModalAIAssistant = useSetRecoilState(modalAIAssistant)

  const { loaded } = useRecoilValue(openAIState)
  const { IsTrial } = storeGet(STORE_KEY_ACCOUNT)

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['EmailMessageBeeEdit', redirectUrl])
  }, [redirectUrl])

  const beeAIAssistantEnabled = evalCondition('co:BEEMSGAIASSISTANT') || IsTrial

  const showModalAI = () => {
    setModalAIAssistant(prev => ({
      ...prev,
      show: true
    }))
  }

  const ControlsComponent = () => {
    return (
      <Flex alignItems='center' gap='8px;'>
        {beeAIAssistantEnabled && (
          <StyledLink
            variant='highlight'
            onClick={showModalAI}
            disabled={!loaded}
          >
            <StyledImgAI src={aiIcon} />
            {intl.formatMessage({
              id: 'Load.Bee.UpsellModalLink'
            })}
          </StyledLink>
        )}
        {previewActive ? (
          <StyledButtonClosePreview
            data-mu-test='preview-close-button'
            icon='cancel-circle'
            family='sli'
            onClick={closePreview}
          />
        ) : (
          <SaveMessageButton />
        )}
      </Flex>
    )
  }

  return (
    <>
      <StyledHeader
        title={<TruncateAndTooltip text={title} forceTooltipRebuild />}
        breadcrumbsItems={[]}
        ControlsComponent={ControlsComponent}
      />
    </>
  )
}

export default Header

const StyledHeader = styled(PageHeader)`
  height: 60px;
  z-index: 1000;
  padding: 10px;
  padding-left: 20px;
  width: 100%;

  .b-page-header__wrapper {
    max-width: 100%;
  }
  h1 {
    flex-basis: 50%;
  }
  .b-page-header__controls {
    flex-basis: 50%;
  }
`

const StyledButtonClosePreview = styled(Icon)`
  margin-right: 10px;
  cursor: pointer;
  font-size: 24px;
  font-weight: 500;
  color: rgb(37, 37, 37);
  :hover:before {
    color: rgb(37, 37, 37);
  }
`
